
import React, { useState } from 'react';
import Layout from '../../../components/layout/Layout';

interface Nivel {
  id: number;
  nome: string;
  xpNecessario: number;
  cor: string;
  icone: string;
  beneficios: string[];
  acessoJogos: string[];
  acessoProdutos: string[];
  distintivosAutomaticos: string[];
  participantes: number;
  evolucaoMedia: number;
}

interface Participante {
  id: number;
  nome: string;
  email: string;
  xpAtual: number;
  dataAlcance: string;
  tempoNoNivel: string;
}

export default function NiveisPage() {
  const [niveis, setNiveis] = useState<Nivel[]>([
    {
      id: 1,
      nome: 'Bronze',
      xpNecessario: 0,
      cor: '#CD7F32',
      icone: '🥉',
      beneficios: ['Acesso básico à plataforma', 'Participação em missões simples'],
      acessoJogos: ['Bingo Básico'],
      acessoProdutos: ['Produtos Bronze'],
      distintivosAutomaticos: ['Iniciante'],
      participantes: 245,
      evolucaoMedia: 150
    },
    {
      id: 2,
      nome: 'Prata',
      xpNecessario: 1000,
      cor: '#C0C0C0',
      icone: '🥈',
      beneficios: ['Acesso a missões intermediárias', 'Bônus de 10% em XP'],
      acessoJogos: ['Bingo Básico', 'Roleta Bronze'],
      acessoProdutos: ['Produtos Bronze', 'Produtos Prata'],
      distintivosAutomaticos: ['Iniciante', 'Progresso'],
      participantes: 189,
      evolucaoMedia: 450
    },
    {
      id: 3,
      nome: 'Ouro',
      xpNecessario: 5000,
      cor: '#FFD700',
      icone: '🥇',
      beneficios: ['Acesso a missões avançadas', 'Bônus de 20% em XP', 'Prioridade no suporte'],
      acessoJogos: ['Bingo Básico', 'Roleta Bronze', 'Roleta Prata', 'Raspadinha'],
      acessoProdutos: ['Produtos Bronze', 'Produtos Prata', 'Produtos Ouro'],
      distintivosAutomaticos: ['Iniciante', 'Progresso', 'Destaque'],
      participantes: 87,
      evolucaoMedia: 1200
    },
    {
      id: 4,
      nome: 'Platina',
      xpNecessario: 15000,
      cor: '#E5E4E2',
      icone: '💎',
      beneficios: ['Acesso a missões exclusivas', 'Bônus de 30% em XP', 'Suporte VIP', 'Acesso antecipado a novos jogos'],
      acessoJogos: ['Todos os jogos', 'Rifas Exclusivas'],
      acessoProdutos: ['Todos os produtos', 'Produtos Platina'],
      distintivosAutomaticos: ['Iniciante', 'Progresso', 'Destaque', 'Elite'],
      participantes: 34,
      evolucaoMedia: 3500
    },
    {
      id: 5,
      nome: 'Diamante',
      xpNecessario: 50000,
      cor: '#B9F2FF',
      icone: '💠',
      beneficios: ['Acesso total à plataforma', 'Bônus de 50% em XP', 'Suporte dedicado', 'Eventos exclusivos', 'Mentoria personalizada'],
      acessoJogos: ['Todos os jogos', 'Rifas Exclusivas', 'Torneios VIP'],
      acessoProdutos: ['Todos os produtos', 'Produtos Diamante', 'Experiências Exclusivas'],
      distintivosAutomaticos: ['Iniciante', 'Progresso', 'Destaque', 'Elite', 'Lendário'],
      participantes: 12,
      evolucaoMedia: 8900
    }
  ]);

  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showParticipantesModal, setShowParticipantesModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [editingNivel, setEditingNivel] = useState<Nivel | null>(null);
  const [viewingNivel, setViewingNivel] = useState<Nivel | null>(null);
  const [deletingNivel, setDeletingNivel] = useState<Nivel | null>(null);
  const [selectedNivelParticipantes, setSelectedNivelParticipantes] = useState<Nivel | null>(null);

  const [formData, setFormData] = useState({
    nome: '',
    xpNecessario: 0,
    cor: '#000000',
    icone: '🏆',
    beneficios: '',
    acessoJogos: '',
    acessoProdutos: '',
    distintivosAutomaticos: ''
  });

  // Mock de participantes
  const participantesMock: Participante[] = [
    { id: 1, nome: 'João Silva', email: 'joao@email.com', xpAtual: 1250, dataAlcance: '15/01/2025', tempoNoNivel: '45 dias' },
    { id: 2, nome: 'Maria Santos', email: 'maria@email.com', xpAtual: 1180, dataAlcance: '18/01/2025', tempoNoNivel: '42 dias' },
    { id: 3, nome: 'Pedro Costa', email: 'pedro@email.com', xpAtual: 1420, dataAlcance: '10/01/2025', tempoNoNivel: '50 dias' },
    { id: 4, nome: 'Ana Oliveira', email: 'ana@email.com', xpAtual: 1090, dataAlcance: '22/01/2025', tempoNoNivel: '38 dias' },
    { id: 5, nome: 'Carlos Souza', email: 'carlos@email.com', xpAtual: 1350, dataAlcance: '12/01/2025', tempoNoNivel: '48 dias' }
  ];

  const handleOpenNew = () => {
    setEditingNivel(null);
    setFormData({
      nome: '',
      xpNecessario: 0,
      cor: '#000000',
      icone: '🏆',
      beneficios: '',
      acessoJogos: '',
      acessoProdutos: '',
      distintivosAutomaticos: ''
    });
    setShowModal(true);
  };

  const handleEdit = (nivel: Nivel) => {
    setEditingNivel(nivel);
    setFormData({
      nome: nivel.nome,
      xpNecessario: nivel.xpNecessario,
      cor: nivel.cor,
      icone: nivel.icone,
      beneficios: nivel.beneficios.join('\n'),
      acessoJogos: nivel.acessoJogos.join(', '),
      acessoProdutos: nivel.acessoProdutos.join(', '),
      distintivosAutomaticos: nivel.distintivosAutomaticos.join(', ')
    });
    setShowModal(true);
  };

  const handleView = (nivel: Nivel) => {
    setViewingNivel(nivel);
    setShowViewModal(true);
  };

  const handleDelete = (nivel: Nivel) => {
    setDeletingNivel(nivel);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (deletingNivel) {
      setNiveis(niveis.filter(n => n.id !== deletingNivel.id));
      setShowDeleteModal(false);
      setDeletingNivel(null);
    }
  };

  const handleViewParticipantes = (nivel: Nivel) => {
    setSelectedNivelParticipantes(nivel);
    setShowParticipantesModal(true);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const nivelData: Nivel = {
      id: editingNivel?.id || Date.now(),
      nome: formData.nome,
      xpNecessario: formData.xpNecessario,
      cor: formData.cor,
      icone: formData.icone,
      beneficios: formData.beneficios.split('\n').filter(b => b.trim()),
      acessoJogos: formData.acessoJogos.split(',').map(j => j.trim()).filter(j => j),
      acessoProdutos: formData.acessoProdutos.split(',').map(p => p.trim()).filter(p => p),
      distintivosAutomaticos: formData.distintivosAutomaticos.split(',').map(d => d.trim()).filter(d => d),
      participantes: editingNivel?.participantes || 0,
      evolucaoMedia: editingNivel?.evolucaoMedia || 0
    };

    if (editingNivel) {
      setNiveis(niveis.map(n => n.id === editingNivel.id ? nivelData : n));
    } else {
      setNiveis([...niveis, nivelData]);
    }

    setShowModal(false);
  };

  const icones = ['🏆', '🥉', '🥈', '🥇', '💎', '💠', '⭐', '🌟', '✨', '👑', '🔥', '⚡'];

  return (
    <Layout>
      <div className="p-8">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Níveis & Progressão</h1>
            <p className="text-gray-600 mt-2">Gerencie os níveis de progressão baseados em XP</p>
          </div>
          <button
            onClick={handleOpenNew}
            className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-lg font-medium flex items-center gap-2 transition-colors whitespace-nowrap"
          >
            <i className="ri-add-line text-xl"></i>
            Novo Nível
          </button>
        </div>

        {/* Estatísticas */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-xl p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">Total de Níveis</p>
                <p className="text-3xl font-bold text-gray-900">{niveis.length}</p>
              </div>
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center">
                <i className="ri-bar-chart-box-line text-2xl text-teal-600"></i>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">Total de Participantes</p>
                <p className="text-3xl font-bold text-gray-900">{niveis.reduce((acc, n) => acc + n.participantes, 0)}</p>
              </div>
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <i className="ri-group-line text-2xl text-blue-600"></i>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">XP Médio</p>
                <p className="text-3xl font-bold text-gray-900">
                  {Math.round(niveis.reduce((acc, n) => acc + n.evolucaoMedia, 0) / niveis.length).toLocaleString()}
                </p>
              </div>
              <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
                <i className="ri-star-line text-2xl text-yellow-600"></i>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">Nível Máximo</p>
                <p className="text-3xl font-bold text-gray-900">
                  {Math.max(...niveis.map(n => n.xpNecessario)).toLocaleString()} XP
                </p>
              </div>
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                <i className="ri-trophy-line text-2xl text-purple-600"></i>
              </div>
            </div>
          </div>
        </div>

        {/* Lista de Níveis */}
        <div className="bg-white rounded-xl border border-gray-200">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Nível</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">XP Necessário</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Participantes</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">XP Médio</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">Benefícios</th>
                  <th className="px-6 py-4 text-right text-sm font-semibold text-gray-900">Ações</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {niveis.sort((a, b) => a.xpNecessario - b.xpNecessario).map((nivel) => (
                  <tr key={nivel.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <div 
                          className="w-12 h-12 rounded-lg flex items-center justify-center text-2xl"
                          style={{ backgroundColor: `${nivel.cor}20` }}
                        >
                          {nivel.icone}
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900">{nivel.nome}</p>
                          <p className="text-sm text-gray-500" style={{ color: nivel.cor }}>
                            Cor: {nivel.cor}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        <i className="ri-star-fill text-yellow-500"></i>
                        <span className="font-semibold text-gray-900">
                          {nivel.xpNecessario.toLocaleString()} XP
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <button
                        onClick={() => handleViewParticipantes(nivel)}
                        className="flex items-center gap-2 text-teal-600 hover:text-teal-700 font-medium cursor-pointer"
                      >
                        <i className="ri-group-line"></i>
                        {nivel.participantes} participantes
                      </button>
                    </td>
                    <td className="px-6 py-4">
                      <span className="text-gray-900 font-medium">
                        {nivel.evolucaoMedia.toLocaleString()} XP
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-teal-100 text-teal-700">
                        {nivel.beneficios.length} benefícios
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center justify-end gap-2">
                        <button
                          onClick={() => handleView(nivel)}
                          className="w-9 h-9 flex items-center justify-center text-blue-600 hover:bg-blue-50 rounded-lg transition-colors cursor-pointer"
                          title="Visualizar"
                        >
                          <i className="ri-eye-line text-lg"></i>
                        </button>
                        <button
                          onClick={() => handleEdit(nivel)}
                          className="w-9 h-9 flex items-center justify-center text-teal-600 hover:bg-teal-50 rounded-lg transition-colors cursor-pointer"
                          title="Editar"
                        >
                          <i className="ri-edit-line text-lg"></i>
                        </button>
                        <button
                          onClick={() => handleDelete(nivel)}
                          className="w-9 h-9 flex items-center justify-center text-red-600 hover:bg-red-50 rounded-lg transition-colors cursor-pointer"
                          title="Excluir"
                        >
                          <i className="ri-delete-bin-line text-lg"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Modal de Cadastro/Edição */}
        {showModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
                <h2 className="text-2xl font-bold text-gray-900">
                  {editingNivel ? 'Editar Nível' : 'Novo Nível'}
                </h2>
                <button
                  onClick={() => setShowModal(false)}
                  className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>

              <form onSubmit={handleSubmit} className="p-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Nome */}
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Nome do Nível *
                    </label>
                    <input
                      type="text"
                      value={formData.nome}
                      onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                      placeholder="Ex: Bronze, Prata, Ouro..."
                      required
                    />
                  </div>

                  {/* XP Necessário */}
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      XP Necessário *
                    </label>
                    <input
                      type="number"
                      value={formData.xpNecessario}
                      onChange={(e) => setFormData({ ...formData, xpNecessario: parseInt(e.target.value) })}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                      placeholder="0"
                      min="0"
                      required
                    />
                  </div>

                  {/* Cor */}
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Cor do Nível *
                    </label>
                    <div className="flex items-center gap-3">
                      <input
                        type="color"
                        value={formData.cor}
                        onChange={(e) => setFormData({ ...formData, cor: e.target.value })}
                        className="w-16 h-10 border border-gray-300 rounded-lg cursor-pointer"
                      />
                      <input
                        type="text"
                        value={formData.cor}
                        onChange={(e) => setFormData({ ...formData, cor: e.target.value })}
                        className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                        placeholder="#000000"
                      />
                    </div>
                  </div>

                  {/* Ícone */}
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Ícone *
                    </label>
                    <div className="grid grid-cols-6 gap-2">
                      {icones.map((icone) => (
                        <button
                          key={icone}
                          type="button"
                          onClick={() => setFormData({ ...formData, icone })}
                          className={`w-full h-10 flex items-center justify-center text-2xl rounded-lg border-2 transition-all cursor-pointer ${
                            formData.icone === icone
                              ? 'border-teal-500 bg-teal-50'
                              : 'border-gray-200 hover:border-gray-300'
                          }`}
                        >
                          {icone}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Benefícios */}
                <div className="mt-6">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Benefícios do Nível
                  </label>
                  <textarea
                    value={formData.beneficios}
                    onChange={(e) => setFormData({ ...formData, beneficios: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    rows={4}
                    placeholder="Digite um benefício por linha&#10;Ex:&#10;Acesso básico à plataforma&#10;Participação em missões simples&#10;Bônus de 10% em XP"
                  />
                  <p className="text-xs text-gray-500 mt-1">Um benefício por linha</p>
                </div>

                {/* Acesso a Jogos */}
                <div className="mt-6">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Acesso a Jogos
                  </label>
                  <input
                    type="text"
                    value={formData.acessoJogos}
                    onChange={(e) => setFormData({ ...formData, acessoJogos: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder="Ex: Bingo Básico, Roleta Bronze, Raspadinha"
                  />
                  <p className="text-xs text-gray-500 mt-1">Separe os jogos por vírgula</p>
                </div>

                {/* Acesso a Produtos */}
                <div className="mt-6">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Acesso a Produtos
                  </label>
                  <input
                    type="text"
                    value={formData.acessoProdutos}
                    onChange={(e) => setFormData({ ...formData, acessoProdutos: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder="Ex: Produtos Bronze, Produtos Prata, Produtos Ouro"
                  />
                  <p className="text-xs text-gray-500 mt-1">Separe os produtos por vírgula</p>
                </div>

                {/* Distintivos Automáticos */}
                <div className="mt-6">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Distintivos Automáticos
                  </label>
                  <input
                    type="text"
                    value={formData.distintivosAutomaticos}
                    onChange={(e) => setFormData({ ...formData, distintivosAutomaticos: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder="Ex: Iniciante, Progresso, Destaque"
                  />
                  <p className="text-xs text-gray-500 mt-1">Separe os distintivos por vírgula</p>
                </div>

                {/* Botões */}
                <div className="flex items-center justify-end gap-3 mt-8 pt-6 border-t border-gray-200">
                  <button
                    type="button"
                    onClick={() => setShowModal(false)}
                    className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="px-6 py-2 bg-teal-600 hover:bg-teal-700 text-white rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {editingNivel ? 'Salvar Alterações' : 'Criar Nível'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Modal de Visualização */}
        {showViewModal && viewingNivel && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
                <h2 className="text-2xl font-bold text-gray-900">Detalhes do Nível</h2>
                <button
                  onClick={() => setShowViewModal(false)}
                  className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>

              <div className="p-6">
                {/* Cabeçalho do Nível */}
                <div className="flex items-center gap-4 mb-6 p-6 rounded-xl" style={{ backgroundColor: `${viewingNivel.cor}10` }}>
                  <div 
                    className="w-20 h-20 rounded-xl flex items-center justify-center text-4xl"
                    style={{ backgroundColor: `${viewingNivel.cor}30` }}
                  >
                    {viewingNivel.icone}
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900">{viewingNivel.nome}</h3>
                    <p className="text-gray-600 mt-1">
                      <i className="ri-star-fill text-yellow-500 mr-1"></i>
                      {viewingNivel.xpNecessario.toLocaleString()} XP necessários
                    </p>
                  </div>
                </div>

                {/* Estatísticas */}
                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div className="bg-gray-50 rounded-lg p-4">
                    <p className="text-sm text-gray-600 mb-1">Participantes</p>
                    <p className="text-2xl font-bold text-gray-900">{viewingNivel.participantes}</p>
                  </div>
                  <div className="bg-gray-50 rounded-lg p-4">
                    <p className="text-sm text-gray-600 mb-1">XP Médio</p>
                    <p className="text-2xl font-bold text-gray-900">{viewingNivel.evolucaoMedia.toLocaleString()}</p>
                  </div>
                </div>

                {/* Benefícios */}
                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                    <i className="ri-gift-line text-teal-600"></i>
                    Benefícios
                  </h4>
                  <ul className="space-y-2">
                    {viewingNivel.beneficios.map((beneficio, index) => (
                      <li key={index} className="flex items-start gap-2 text-gray-700">
                        <i className="ri-check-line text-teal-600 mt-0.5"></i>
                        <span>{beneficio}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Acesso a Jogos */}
                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                    <i className="ri-gamepad-line text-teal-600"></i>
                    Acesso a Jogos
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {viewingNivel.acessoJogos.map((jogo, index) => (
                      <span key={index} className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm">
                        {jogo}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Acesso a Produtos */}
                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                    <i className="ri-shopping-bag-line text-teal-600"></i>
                    Acesso a Produtos
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {viewingNivel.acessoProdutos.map((produto, index) => (
                      <span key={index} className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-sm">
                        {produto}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Distintivos Automáticos */}
                <div>
                  <h4 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                    <i className="ri-medal-line text-teal-600"></i>
                    Distintivos Automáticos
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {viewingNivel.distintivosAutomaticos.map((distintivo, index) => (
                      <span key={index} className="px-3 py-1 bg-yellow-100 text-yellow-700 rounded-full text-sm">
                        {distintivo}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Participantes */}
        {showParticipantesModal && selectedNivelParticipantes && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
              <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
                <div>
                  <h2 className="text-2xl font-bold text-gray-900">
                    Participantes - {selectedNivelParticipantes.nome}
                  </h2>
                  <p className="text-gray-600 mt-1">
                    {selectedNivelParticipantes.participantes} participantes neste nível
                  </p>
                </div>
                <button
                  onClick={() => setShowParticipantesModal(false)}
                  className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>

              <div className="p-6">
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-gray-50 border-b border-gray-200">
                      <tr>
                        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Participante</th>
                        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">XP Atual</th>
                        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Data de Alcance</th>
                        <th className="px-4 py-3 text-left text-sm font-semibold text-gray-900">Tempo no Nível</th>
                        <th className="px-4 py-3 text-right text-sm font-semibold text-gray-900">Ações</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {participantesMock.map((participante) => (
                        <tr key={participante.id} className="hover:bg-gray-50 transition-colors">
                          <td className="px-4 py-4">
                            <div>
                              <p className="font-semibold text-gray-900">{participante.nome}</p>
                              <p className="text-sm text-gray-500">{participante.email}</p>
                            </div>
                          </td>
                          <td className="px-4 py-4">
                            <div className="flex items-center gap-2">
                              <i className="ri-star-fill text-yellow-500"></i>
                              <span className="font-semibold text-gray-900">
                                {participante.xpAtual.toLocaleString()} XP
                              </span>
                            </div>
                          </td>
                          <td className="px-4 py-4">
                            <span className="text-gray-700">{participante.dataAlcance}</span>
                          </td>
                          <td className="px-4 py-4">
                            <span className="text-gray-700">{participante.tempoNoNivel}</span>
                          </td>
                          <td className="px-4 py-4">
                            <div className="flex items-center justify-end gap-2">
                              <button
                                className="w-9 h-9 flex items-center justify-center text-blue-600 hover:bg-blue-50 rounded-lg transition-colors cursor-pointer"
                                title="Ver Perfil"
                              >
                                <i className="ri-user-line text-lg"></i>
                              </button>
                              <button
                                className="w-9 h-9 flex items-center justify-center text-teal-600 hover:bg-teal-50 rounded-lg transition-colors cursor-pointer"
                                title="Ver Histórico"
                              >
                                <i className="ri-history-line text-lg"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Confirmação de Exclusão */}
        {showDeleteModal && deletingNivel && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl max-w-md w-full">
              <div className="p-6">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-alert-line text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 text-center mb-2">
                  Excluir Nível?
                </h3>
                <p className="text-gray-600 text-center mb-6">
                  Tem certeza que deseja excluir o nível <strong>{deletingNivel.nome}</strong>?
                  Esta ação não pode ser desfeita.
                </p>
                <div className="flex items-center gap-3">
                  <button
                    onClick={() => setShowDeleteModal(false)}
                    className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={confirmDelete}
                    className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Excluir
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
